'use strict';

import * as Onyx from '../../lib/onyx.min.js';

import {default as SkyShader} from '../../shaders/sky.js';

import {default as Background} from '../../entities/background.js';
import {default as Player} from '../../entities/player.js';

let Camera = Onyx.Camera;
let Light = Onyx.Light;
const ENTITY_CLASSES = { Background, Camera, Light, Player };

const DEBUG_PLAYER_NURBS = false;

const PLAY_MUSIC = true;
const MUSIC_VOLUME = 0.3;
const MUSIC_VOLUME_PEDAGOGIC = 0.2;
const INITIAL_FOV = 0.872665; // 50 Degrees
const TIME_BEFORE_HIDE_MASK = 1000; // 1 seconds
const TIME_BEFORE_COUNTDOWN_START = 3000; // 3 seconds
const PEDAGOGIC_TIMING = 7000; // 7 seconds
const PEDAGOGIC_TIME_GIVEN_TO_ANSWER = 3000; // 3 seconds
const PLAYER_SPACING = 10;
const MAX_LAPS = 3;

import {default as Levels} from '../../scripts/levels';
import {default as Vehicles} from '../../scripts/vehicles.js';

export default class SceneGame extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/game/index.html',
            clock: new Onyx.Clock()
        });

        this.physicsEnabled = true;

        window.debug = false;

        this.timeUp = false;
        this.roundCount = 0;

        this.gametime = 0;
        this.laps = 0;
        this.players = [];
        this.cameraYawOffset = 0;

        this.levelsPlayedBag = []; // This is so they get a random level each time

        this.renderPasses = [
            // new Onyx.RenderPassShadow({
            //     width: 2048,
            //     height: 2048,
            //     maxDistance: 100,
                // renderPasses: [
                    new Onyx.RenderPass({
                        renderPasses: [
                            new Onyx.RenderPassShader({
                                viewportClear: false,
                                shader: new SkyShader()
                            })
                        ]
                    })
                // ]
            // })
        ];
    }

    onload(){
        super.onload();

        Howler.masterGain.gain.value = 0; // Mute howler while loading in sounds otherwise it makes blurps

        this.isGameover = false;
        this.isStarted = false;
        this.gametime = 0;

        this.setupScene();
        this.loadLevel();

        // Fix for music not playing on Kindle Fire: Queue music but pause it until it's ready.
        game.music["main"].play();
        game.music["main"].pause();

        game.music["main"].volume(MUSIC_VOLUME);

        this.setTimeout(() => {
            game.hideLoadingMask();

            this.setTimeout(() => {
                this.startRound();
            }, TIME_BEFORE_COUNTDOWN_START);
        }, TIME_BEFORE_HIDE_MASK);

        this.debugCubes = [];

        this.debugCubes[0] = new Onyx.Entity({
            visible: DEBUG_PLAYER_NURBS,
            components: [new Onyx.Model({
                meshes: [new Onyx.Mesh({
                    id: "debug",
                    material: new Onyx.MaterialPhong({lighting: 0, diffuseColor: new Onyx.Color(1,0,0)})
                }).addCube()]
            })]
        });
        this.add(this.debugCubes[0]);

        this.debugCubes[1] = new Onyx.Entity({
            visible: DEBUG_PLAYER_NURBS,
            components: [new Onyx.Model({
                meshes: [new Onyx.Mesh({
                    id: "debug",
                    material: new Onyx.MaterialPhong({lighting: 0, diffuseColor: new Onyx.Color(0,0,1)})
                }).addCube()]
            })]
        });
        this.add(this.debugCubes[1]);

        this.debugCubes[2] = new Onyx.Entity({
            visible: DEBUG_PLAYER_NURBS,
            components: [new Onyx.Model({
                meshes: [new Onyx.Mesh({
                    id: "debug",
                    material: new Onyx.MaterialPhong({lighting: 0, diffuseColor: new Onyx.Color(0,1,0)})
                }).addCube()]
            })]
        });
        this.add(this.debugCubes[2]);
    }

    update(dt){
        super.update(...arguments);
        if(this.modalPedagogic) this.modalPedagogic.module.update(...arguments);

        if(!this.entities.length) return;

        if(!this.isGameover && this.player.laps >= MAX_LAPS - 1) this.gameover();

        this.cameras[0].transform.x = this.player.transform.x;
        this.cameras[0].transform.y = this.player.transform.y + 5;
        this.cameras[0].transform.z = this.player.transform.z + 18 - ((this.player.velocity / this.player.topSpeedConst) * 1.5);
        this.cameras[0].transform.orbitY(this.player.angularVelocity - this.cameraYawOffset, this.player.transform.xyz);
        if(!this.isGameover){
            this.cameras[0].transform.targetTo(this.player.destinationMid);
        }else{
            this.cameras[0].transform.targetTo(this.player.destinationMid);
            // this.cameras[0].transform.targetTo(this.player.transform.xyz);
        }
        this.cameras[0].transform.yaw = this.player.destinationAngle - this.cameraYawOffset;
        this.cameras[0].fov = INITIAL_FOV + ((this.player.velocity / this.player.topSpeedConst) * 0.2);
        this.viewports[0].evaluate(false);

        if(this.isGameover) return;

        this.players.sort((a, b) => {
            return (b.currentNURBSIndex + (b.laps * this.subNURBS.length)) - (a.currentNURBSIndex + (a.laps * this.subNURBS.length));
        });

        Howler.pos(this.cameras[0].transform.x, this.cameras[0].transform.y, this.cameras[0].transform.z);
        Howler.orientation(0, this.player.destinationAngle - this.cameraYawOffset, 0, 0, 1, 0);

        // this.cameras[0].transform.x = this.player.transform.x + (Math.sin(this.player.transform.yaw) * 20);
        // this.cameras[0].transform.z = this.player.transform.z + (Math.cos(this.player.transform.yaw) * 20);
        // let rot = [];
        // Onyx.mat4.getRotation(rot, this.player.transform._temp.mat4);
        // document.getElementById("student-name").innerHTML = this.player.currentOffset + " | " + this.player.steer + " | " +  Math.round(this.player.velocity * 100) + " km/h";
        // document.getElementById("student-name").innerHTML = Math.round(this.player.velocity * 100) + " km/h";

        // Performance Optimization: Only update DOM if necessary
        if(document.getElementById("laps").innerHTML * 1 !== Math.max(this.player.laps, 0) + 1) document.getElementById("laps").innerHTML = Math.max(this.player.laps, 0) + 1;
        if(document.getElementById("place").innerHTML * 1 !== this.players.indexOf(this.player) + 1) document.getElementById("place").innerHTML = this.players.indexOf(this.player) + 1;

        if(this.isStarted) this.gametime += dt;

        let seconds = this.gametime / 1000 | 0;
        let minutes = seconds / 60 | 0;
        seconds = seconds % 60;

        // Performance Optimization: Only update DOM if necessary
        if(document.getElementById("time").innerHTML != (minutes + "").padStart(2, "0") + ":" + (seconds + "").padStart(2, "0"))
            document.getElementById("time").innerHTML = (minutes + "").padStart(2, "0") + ":" + (seconds + "").padStart(2, "0");

    }

    showPedagogic(){
        if(this.isGameover) return;

        this.viewports[0].evaluate(false); // iOS 11 needs a refresher once in awhile.

        game.music["main"].fade(MUSIC_VOLUME, MUSIC_VOLUME_PEDAGOGIC, 250);

        this.modalPedagogic = router.modal("pedagogic", () => {
            this.viewports[0].evaluate(false); // iOS 11 needs a refresher once in awhile.

            this.correctInARow++;

            game.music["main"].fade(MUSIC_VOLUME_PEDAGOGIC, MUSIC_VOLUME, 250);

            this.setTimeout(() => {
                this.player.boost();

                this.timerShowPedagogic = this.setTimeout(() => {
                    this.showPedagogic();
                }, PEDAGOGIC_TIMING);
            }, 250);

            this.modalPedagogic = null;
        }, () => {
            this.viewports[0].evaluate(false); // iOS 11 needs a refresher once in awhile.

            this.correctInARow = 0;

            game.music["main"].fade(MUSIC_VOLUME_PEDAGOGIC, MUSIC_VOLUME, 250);

            this.setTimeout(() => {
                this.player.burnout();

                document.getElementById("scene-game").classList.remove("blurry");

                this.timerShowPedagogic = this.setTimeout(() => {
                    this.showPedagogic();
                }, PEDAGOGIC_TIMING);
            }, 250);

            this.modalPedagogic = null;
        }, null, {view: "modal"});

        // Auto answer
        this.setTimeout(() => {
            router.map["pedagogic"].module.emit("onanswerquestion", (this.player.currentOffset < 0)?0:1);
        }, PEDAGOGIC_TIME_GIVEN_TO_ANSWER);
    }

    setupScene(){
		document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.first_name}", centralStation.player.first_name);
        document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.last_name}", centralStation.player.last_name);

        this.ambientLightColor.set(0.25, 0.25, 0.25, 1);
        this.directionalLight.diffuseColor.set(1.0, 1.0, 1.0, 1);
        this.directionalLight.vector = [-0.15, -0.95, 0.15];

        this.fogColor.set(125 / 255, 165 / 255, 200 / 255);
        this.fogDensity = 0.5;
    }

    chooseNewRandomLevel(){
        let level = Math.floor(Math.random() * Levels.length);

        // Reset bag if we've already played all of them
        if(this.levelsPlayedBag.length === Levels.length) this.levelsPlayedBag = [];

        // Try again if we've already picked this level
        if(this.levelsPlayedBag.indexOf(level) > -1) return this.chooseNewRandomLevel();

        return level;
    }

    loadLevel(level = this.chooseNewRandomLevel()){
        this.roundCount++;
        this.laps = 0;
        this.players = [];
        this.currentLevel = Levels[level];

        this.levelsPlayedBag.push(level);

        // Reduce control points array into 2 dimensions ([1,2,3,4,5,6,7,8] -> [[1,2,3,4],[5,6,7,8]...])
        let controlPoints = Levels[level].NURBSControlPoints.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index/4);

            if(!resultArray[chunkIndex]) {
              resultArray[chunkIndex] = []; // start a new chunk
            }

            resultArray[chunkIndex].push(item);

            return resultArray;
        }, []);

        this.nurbsCurve = new Onyx.NURBSCurve({id: "NURBS", degree: 3, controlPoints: controlPoints, knots: Levels[level].NURBSKnots});

        // Split nurbs up
        this.subNURBS = [];
        for(let i = 0; i <= Levels[level].NURBSDivisions; i++){
            let point = this.nurbsCurve.getPointAt(i / Levels[level].NURBSDivisions);

            this.subNURBS.push(point);
        }

        // this.focus = Levels[level].focus;
        // this.cameras[0].limit.maximum.x = this.focus[0] + 500;
        // this.cameras[0].transform.translateTo(this.focus[0], this.focus[1], this.focus[2]);

        let playerCount = 0;
        let selectedMaterials = [game.playerColorSelected];

        for(let entity of Levels[level].entities){
            if(entity.class == "Player"){
                entity.options.startingNURBS = -playerCount * PLAYER_SPACING - 1; // -1 makes sure that they start behind the line

                if(entity.options.isPlayer){
                    entity.options.materialNo = game.playerColorSelected;
                    entity.options.name = centralStation.player.first_name + " " + centralStation.player.last_name;
                }else{
                    while(entity.options.materialNo === undefined || selectedMaterials.indexOf(entity.options.materialNo) >= 0){
                        entity.options.materialNo = Math.floor(Math.random() * Vehicles.length);
                    }
                    selectedMaterials.push(entity.options.materialNo);
                    if(selectedMaterials.length >= Vehicles.length) selectedMaterials = [game.playerColorSelected];
                    entity.options.name = Vehicles[entity.options.materialNo].name;
                }

                playerCount++;
            }

            let newEntity = new ENTITY_CLASSES[entity.class](entity.options);
            this.add(newEntity);
        }

        if(this.cameras.length){
            this.viewports[0].bindToCamera(this.cameras[0]);
            this.viewports[0].evaluate();
        }
    }

    gameover(){
        this.isGameover = true;

        router.modalUnload(this.modalPedagogic);

        this.cameraYawOffset = 0;
        // this.player.currentOffset = 0;
        this.player.steer = 0;

        let t = new Onyx.Tween();
        t.easeIn(this, "cameraYawOffset", -Math.PI, 2000, () => {});
        this.add(t);

        t = new Onyx.Tween();
        t.easeIn(this.player, "currentOffset", 0, 1000, () => {});
        this.add(t);

        // Hide UI
        document.getElementById("controls").style.display = "none";
        document.getElementsByClassName("laps")[0].style.display = "none";
        document.getElementsByClassName("place")[0].style.display = "none";
        document.getElementsByClassName("time")[0].style.display = "none";

        // Show "Finish!" (zoomIn)
        var countdownElement = document.getElementById("countdown");
        countdownElement.classList.remove("zoomIn");
        this._tCEVoid = countdownElement.offsetWidth;
        countdownElement.classList.add("zoomIn");
        countdownElement.classList.add("sFinish");
        countdownElement.style.display = "";

        this.setTimeout(() => {
            // countdownElement.style.display = "none";
            countdownElement.classList.remove("zoomIn");
            this._tCEVoid = countdownElement.offsetWidth;
            countdownElement.classList.add("fadeOut");

            this.setTimeout(() => {
                router.modal("gameover", null, null, {ranking: this.players, player: this.player}, {view: "modal"});
            }, 500);
        }, 3000);

        // game.sfx["sndGameOver"].play();
        game.music["main"].fade(MUSIC_VOLUME, MUSIC_VOLUME_PEDAGOGIC, 250);
    }

    startRound(){
        var countdownElement = document.getElementById("countdown");
        countdownElement.style.display = "block";
        countdownElement.classList.add("s3");

        Howler.masterGain.gain.value = 1; // Mute howler while loading in sounds otherwise it makes blurps
        game.sfx["countdown"].play();

        // return;

        // Countdown
        // 3...
        this.setTimeout(() => {
            // 2...
            countdownElement.classList.add("s2");

            // Reset animation
            countdownElement.classList.remove("zoomIn");
            this._tCEVoid = countdownElement.offsetWidth; // Reset CSS animation state
            countdownElement.classList.add("zoomIn");

            this.setTimeout(() => {
                // 1...
                countdownElement.classList.add("s1");

                countdownElement.classList.remove("zoomIn");
                this._tCEVoid = countdownElement.offsetWidth;
                countdownElement.classList.add("zoomIn");

                this.setTimeout(() => {
                    // Go!
                    countdownElement.classList.add("sGo");

                    countdownElement.classList.remove("zoomIn");
                    this._tCEVoid = countdownElement.offsetWidth;
                    countdownElement.classList.add("zoomIn");

                    this.setTimeout(() => {
                        countdownElement.style.display = "none";
                    }, 1000);

                    for(let player of this.players){
                        player.accelerate = true;
                        this.isStarted = true;
                    }

                    this.timerShowPedagogic = this.setTimeout(() => {
                        this.showPedagogic();
                    }, PEDAGOGIC_TIMING);

                    if(PLAY_MUSIC) game.music["main"].play();
                }, 1100);
            }, 1100);
        }, 1100);
    }

    shakeCamera(){
        let shake = CAMERA_SHAKE_FORCE;
        let polarity = 1;
        this.setInterval(() => {
            var angle = (Math.random() * Math.PI) * polarity;
            var px = Math.cos(angle) * shake;
            var py = Math.sin(angle) * shake;

            this.camera.transform.x += px;
            this.camera.transform.y += py;

            shake *= CAMERA_SHAKE_DECAY;
            polarity = (polarity === 1)?-1:1;
        }, 0, CAMERA_SHAKE_TIME / (1000/60));
    }

    // @Onyx.handles("mousedown")
    // @Onyx.handles("touchstart")
    startAccelerate(){
        this.player.accelerate = true;
    }

    @Onyx.handles("mouseup")
    @Onyx.handles("touchend")
    stopAccelerate(){
        // this.player.accelerate = false;
    }

    @Onyx.handles("keydown")
    steerKey(evt){
        if(!this.isStarted) return;

        switch(evt.keyCode){
            case 37: // Left
                this.player.steer = -(this.currentLevel.laneWidth / 2);// Math.max(this.player.currentOffset - (this.currentLevel.laneWidth / 2), -(this.currentLevel.laneWidth / 2));
                break;
            case 39: // Right
                this.player.steer =  (this.currentLevel.laneWidth / 2); //Math.min(this.player.currentOffset + (this.currentLevel.laneWidth / 2),  (this.currentLevel.laneWidth / 2));
                break;
        }
    }

    @Onyx.handles("mousedown", {elementId: "steer-left"})
    @Onyx.handles("touchstart", {elementId: "steer-left"})
    steerLeft(){
        if(!this.isStarted) return;

        this.player.steer = -(this.currentLevel.laneWidth / 2);
        // this.player.steer = -1;
    }

    @Onyx.handles("mousedown", {elementId: "steer-right"})
    @Onyx.handles("touchstart", {elementId: "steer-right"})
    steerRight(){
        if(!this.isStarted) return;

        this.player.steer =  (this.currentLevel.laneWidth / 2);
        // this.player.steer = 1;
    }

    // @Onyx.handles("mouseup", {elementId: "steer-left"})
    // @Onyx.handles("touchend", {elementId: "steer-left"})
    // @Onyx.handles("mouseup", {elementId: "steer-right"})
    // @Onyx.handles("touchend", {elementId: "steer-right"})
    // steerStop(){
    //     this.player.steer = 0;
    // }
}
